<template>
  <v-form ref="form" class="">

    <BaseUtil ref="util" :pageLoading="pageLoading" />
        <v-row>
          <v-col cols="12">
            <v-textarea v-model="entry.correcao" v-bind="getObject('correcao')" label="Detalhes da correção"
              outlined></v-textarea>
          </v-col>
        </v-row>

     
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import gql from 'graphql-tag';
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      seriesList: [],
      numbersListLoading: false,
      seriesListLoading: false,
      pageLoading: false,
      cashFlowsList: [],
      cashFlowsListLoading: false,
      showExtras: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    printing: {
      type: Boolean,
      default: false
    },
    formType: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    // this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  watch: {
    "entry.cashFlowIdsAttribute": function () {
      // console.log("Alterou entry.periodIdsAttribute", this.entry.periodIdsAttribute)
      // this.selectSale();
    },
  },
  methods: {
    getObject: function (element, component) {
      return this.entryAttributes[element];
    },
    activateExtras: function () {
      this.showExtras = !this.showExtras;
    },
    isFormValid: function () {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function () {
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function () {
      this.$refs.form.resetValidation();
    },
  }
};

const NFE_SERIES_QUERY = gql`
  query ($taxPayerId: ID!) {
    accountContext {
      nfeSeries(taxPayerId: $taxPayerId) {
        series
        number
      }
    }
  }
`;

const NFE_NUMBER_QUERY = gql`
  query ($series: Int!, $taxPayerId: ID!) {
    accountContext {
      nfeNumber(series: $series, taxPayerId: $taxPayerId)
    }
  }
`;

</script>

<style scoped>
.row{
  margin: 0px;
}
</style>
